module.exports = __webpack_public_path__ + "static/media/social-icon-facebook.6046acfb.svg";